import type { Resource } from '../../api/client.ts'
import type { WebhookEndpointConfig } from '../../api/webhooks.ts'

import { EndpointsCard } from './EndpointsCard.tsx'
import { PayloadAttemptsCard } from './PayloadAttemptsCard.tsx'
import { PayloadSummaryStats } from './PayloadSummaryStats.tsx'
import { variantsOf } from './types.ts'

// Everything the dashboard shows for payload webhooks — the payload-only
// counterpart to DeliveryWebhooksPane, reading the same shared /config
// resource but showing only the two variants that belong to this type.

const PAYLOAD_VARIANTS = variantsOf('payloads')

const payloadEndpoints = (
  resource: Resource<WebhookEndpointConfig[]>
): Resource<WebhookEndpointConfig[]> =>
  resource.status === 'ready'
    ? {
        ...resource,
        data: resource.data.filter(endpoint =>
          PAYLOAD_VARIANTS.includes(endpoint.variant)
        ),
      }
    : resource

export const PayloadWebhooksPane = ({
  canEdit,
  config,
  windowDays,
  onNavigate,
  onWindowChange,
}: {
  canEdit: boolean
  config: { resource: Resource<WebhookEndpointConfig[]>; refresh: () => void }
  windowDays: number
  onNavigate?: (path: string) => void
  onWindowChange: (next: number) => void
}) => (
  <>
    <PayloadSummaryStats windowDays={windowDays} />
    <EndpointsCard
      canEdit={canEdit}
      onSaved={config.refresh}
      resource={payloadEndpoints(config.resource)}
      type="payloads"
    />
    <PayloadAttemptsCard
      onNavigate={onNavigate}
      onWindowChange={onWindowChange}
      windowDays={windowDays}
    />
  </>
)
